import * as yup from "yup";

import { useEffect } from "react";
import { IoPlayOutline, IoReload } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { paymentConfirmationServices as confirmation } from "./../../../services/paymentConfirmationServices";

import ReactSelect from "../../../components/common/ReactSelect";

const schema = yup.object();

const PaymentConfirmationFilter = ({ options, onFilter }) => {
  const statuses = confirmation.getPaymentConfirmationStatuses();

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (item) => {
    const status =
      item.status && item.status !== undefined ? item.status.value : "";

    onFilter(status);
  };

  const handleReset = () => {
    const status = "";

    onFilter(status);
  };

  useEffect(() => {
    if (options) {
      const { status } = options;

      if (status) {
        const statuses = confirmation.getPaymentConfirmationStatuses();
        const selected = statuses.filter((i) => i.value === status);
        setValue("status", selected[0]);
      }
    }
  }, [options, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div className="col-span-2">
          <ReactSelect
            id="statuses-dropdown"
            name="status"
            title="Status"
            options={statuses}
            control={control}
            register={register("status")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-5 gap-2 pt-5">
        <div className="col-span-2">
          <button
            type="button"
            onClick={handleReset}
            className="button bg-gray-200 text-gray-500"
          >
            Reset <IoReload className="ml-2" />
          </button>
        </div>
        <div className="col-span-3">
          <button type="submit" className="button button-primary">
            Apply Filter <IoPlayOutline className="ml-2" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default PaymentConfirmationFilter;
